import { render, staticRenderFns } from "./features-multi-account.vue?vue&type=template&id=46ab1dd0&scoped=true"
import script from "./features-multi-account.vue?vue&type=script&lang=js"
export * from "./features-multi-account.vue?vue&type=script&lang=js"
import style0 from "./features-multi-account.vue?vue&type=style&index=0&id=46ab1dd0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ab1dd0",
  null
  
)

export default component.exports